import { render } from "./Cs2Event.vue?vue&type=template&id=546de834&scoped=true"
import script from "./Cs2Event.vue?vue&type=script&lang=js"
export * from "./Cs2Event.vue?vue&type=script&lang=js"

import "./Cs2Event.vue?vue&type=style&index=0&id=546de834&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546de834"]])

export default __exports__